import React from 'react';
import {
  FDTableBody,
} from '@facet-wealth/design';
import DataContainer from 'Components/UI/DataContainer';
import PlannerTransitionTableRow
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableContent/PlannerTransitionTableBody/PlannerTransitionTableRow';
import PropTypes from 'prop-types';

const PlannerTransitionTableBody = ({
  plannerTransitionCollection,
  loadingError,
  loading,
}) => {
  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
    >
      <FDTableBody>
        {plannerTransitionCollection.resources().list().map((resource) => {
          return (
            <PlannerTransitionTableRow
              key={resource.id()}
              resource={resource}
              fields={plannerTransitionCollection?.meta().template().list()}
            />
          );
        })}
      </FDTableBody>
    </DataContainer>
  );
};

PlannerTransitionTableBody.defaultProps = {
  loadingError: false,
  loading: false,
};

PlannerTransitionTableBody.propTypes = {
  plannerTransitionCollection: PropTypes.object.isRequired,
  loadingError: PropTypes.bool,
  loading: PropTypes.bool,
};

export default PlannerTransitionTableBody;
